import { render, staticRenderFns } from "./TransferToAssetForm.vue?vue&type=template&id=59bd1aea&"
import script from "./TransferToAssetForm.vue?vue&type=script&lang=ts&"
export * from "./TransferToAssetForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59bd1aea')) {
      api.createRecord('59bd1aea', component.options)
    } else {
      api.reload('59bd1aea', component.options)
    }
    module.hot.accept("./TransferToAssetForm.vue?vue&type=template&id=59bd1aea&", function () {
      api.rerender('59bd1aea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/logistic/transfer-to-asset/TransferToAssetForm.vue"
export default component.exports